import React, { useState, useEffect } from "react";
import axios from "axios";
import { Table, Form, Button, Container } from "react-bootstrap";
import DriverSelector from "../../components/driverSelector";
import { useTranslation } from 'react-i18next';


const IncomeData = () => {
    const { t } = useTranslation();

    const [selectedWeeks, setSelectedWeeks] = useState([]);
    const [incomeData, setIncomeData] = useState([]);
    const [users, setUsers] = useState([]);
    const [selectedUser, setSelectedUser] = useState("");
    const [selectedFirstName, setSelectedFirstName] = useState("");
    const [selectedLastName, setSelectedLastName] = useState("");
    const weeks = Array.from({ length: 52 }, (_, i) => i + 1);

    useEffect(() => {
        console.log("🔍 Виконується запит на отримання користувачів...");
        fetch("https://godrive.com.pl/api/users")
            .then(response => response.json())
            .then(data => {
                console.log("📋 Отримані користувачі:", data);
                setUsers(data);
            })
            .catch(error => console.error("❌ Помилка завантаження користувачів:", error));
    }, []);

    const handleCheckboxChange = (week) => {
        setSelectedWeeks((prevSelected) =>
            prevSelected.includes(week)
                ? prevSelected.filter((w) => w !== week)
                : [...prevSelected, week]
        );
    };

    const handleUserChange = (e) => {
        const userId = Number(e.target.value);
        const selected = users.find(user => user.id === userId);
        
        if (selected) {
            setSelectedUser(userId);
            setSelectedFirstName(selected.firstName);
            setSelectedLastName(selected.lastName);
            console.log("✅ Вибрано користувача:", selected.firstName, selected.lastName);
        } else {
            setSelectedUser("");
            setSelectedFirstName("");
            setSelectedLastName("");
            console.log("⚠️ Користувач не знайдений");
        }
    };

    const fetchIncomeData = () => {
        const [selectedFirstName, selectedLastName] = selectedUser.label.split(" ");

        if (selectedWeeks.length === 0 || !selectedFirstName || !selectedLastName) {
            console.error("❌ Відсутні необхідні дані!", { selectedWeeks, selectedFirstName, selectedLastName });
            return;
        }
    
        console.log("📤 Відправляємо дані:", { weeks: selectedWeeks, first_name: selectedFirstName, last_name: selectedLastName });
    
        axios.post("https://godrive.com.pl/api/cash-data", { 
            weeks: selectedWeeks, 
            first_name: selectedFirstName, 
            last_name: selectedLastName 
        })
        .then((response) => {
            const formattedData = response.data.map(row => ({
                ...row,
                income: row.source === 'Uber' ? Math.abs(parseFloat(row.income)) || 0 : parseFloat(row.income) || 0
            }));
            setIncomeData(formattedData);
        })
        .catch((error) => console.error("❌ Помилка отримання даних:", error));
    };

    const calculateTotals = () => {
        const totals = {};
        incomeData.forEach(({ source, income }) => {
            if (!totals[source]) {
                totals[source] = 0;
            }
            totals[source] += income;
        });
        return totals;
    };

    const totals = calculateTotals();

    return (
        <Container>
            <h2 className="mt-4">{t("cashStatsTitle")}</h2>
            <Form.Group className="mb-3">
                <Form.Label>{t("chooseDriver")}</Form.Label>
                <DriverSelector selectedDriver={selectedUser} setSelectedDriver={setSelectedUser} />

            </Form.Group>
            <Table bordered className="mb-3">
                <tbody>
                    {Array.from({ length: 4 }, (_, rowIndex) => (
                        <tr key={rowIndex}>
                            {weeks.slice(rowIndex * 13, (rowIndex + 1) * 13).map((week) => (
                                <td key={week}>
                                    <Form.Check
                                        type="checkbox"
                                        label={week}
                                        onChange={() => handleCheckboxChange(week)}
                                        checked={selectedWeeks.includes(week)}
                                    />
                                </td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </Table>
            <Button onClick={fetchIncomeData} variant="primary">{t("getData")}</Button>
            <Table striped bordered hover className="mt-4">
                <thead>
                    <tr>
                        <th>{t("week")}</th>
                        <th>{t("service")}</th>
                        <th>{t("cash")}</th>
                    </tr>
                </thead>
                <tbody>
                    {incomeData.map((row, index) => (
                        <tr key={index}>
                            <td>{row.week_number}</td>
                            <td>{row.source}</td>
                            <td>{row.income}</td>
                        </tr>
                    ))}
                    {Object.entries(totals).map(([source, total], index) => (
                        <tr key={`total-${index}`} style={{ fontWeight: "bold", backgroundColor: "#f8f9fa" }}>
                            <td colSpan={2}>{t("total")} ({source})</td>
                            <td>{total}</td>
                        </tr>
                    ))}
                </tbody>
            </Table>
        </Container>
    );
};

export default IncomeData;
